package com.gsb.vyapar.bhagya.presentation.category.view

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material.Checkbox
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.category.event.CategoriesViewUiEvents
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.edittext.CategoryNameEditText
import com.gsb.vyapar.bhagya.presentation.common.menu.OutlinedExpandedMenu
import com.gsb.vyapar.bhagya.presentation.common.text.Text14Regular
import com.gsb.vyapar.bhagya.presentation.common.text.Text24SemiBold
import com.gsb.vyapar.bhagya.theme.black

@Composable
fun AddEditSubCategoryView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    LazyColumn(modifier = Modifier.padding(16.dp), horizontalAlignment = Alignment.CenterHorizontally) {
        item {
            Spacer(Modifier.height(8.dp))
            Text24SemiBold("Add/Edit SubCategory", black)
            Spacer(Modifier.height(8.dp))
            CategoryNameEditText(uiState.categoriesViewUiState.addEditSubCategory.name, "Enter SubCategory Name") {
                onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditSubCategoryName(it)))
            }
            Spacer(Modifier.height(8.dp))
            OutlinedExpandedMenu(uiState.categoriesViewUiState.selectCategory, uiState.categoriesViewUiState.selectCategoryMenuSelectedIndex, uiState.categoriesViewUiState.selectCategoryMenuOptions) {
                onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditSubCategoryCategoryMenuIndex(it)))
            }
            Spacer(Modifier.height(8.dp))
            Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Checkbox(uiState.categoriesViewUiState.addEditSubCategory.deleted, onCheckedChange = {
                    onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditSubCategoryDeleted(it)))
                })
                Text14Regular("Deleted", black)
            }
            GVBButton(text = "Save", onClick = { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditSubCategorySave)) })
        }
    }
}